// extracted by mini-css-extract-plugin
module.exports = {"item":"Entry_item__2SdiH","icon":"Entry_icon__1TtY6","img":"Entry_img__3Xhy5","body":"Entry_body__3cft-"};